var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVillaLogoCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 281 112",
    style: {
      enableBackground: "new 0 0 281 112.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#13343B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marks"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,110.1C19.5,110.1,7,103,7,76.6V48c0-7.2-6.4-8.9-6.4-12.5V35c0.1-1.8,1.5-3.3,3.3-3.5l18.8-3.1 c4.1-0.5,6.6,0.2,6.6,3l-0.4,52.4c-0.2,12,3,16.8,10,17c14.3,0.3,27-18,27-36.2c0-15.2-14.7-14.3-14.7-26.9c0-5.6,3.6-9.9,10.9-9.9 c9.1,0,16.6,7.2,16.6,25.7C78.9,87.7,59.2,110.1,33.5,110.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.3,47l-14.2-2.4c-3.5-0.7-5.8,0.8-5.8,3.4v2.7c-4.2-4.2-10-6.9-17.7-6.9c-17.3,0-31.9,13.7-31.9,33.7 c0,21.8,15.3,34,31.8,34c7,0,13.7-2.6,17.9-7.6v3.2c0,1.7,1.3,3,3,3h0.1H277c1.8,0,2.7-0.8,2.7-2.3v-0.4c0-3.2-5.3-4.6-5.3-10.3 V61.6c0-6.6,5.7-8.2,5.7-10.8v-0.4C280.3,48.7,279,47.2,277.3,47z M255.4,91.1c0,9.6-6,14.5-11.5,14.5 c-11.2-0.4-17.5-21.2-16.9-36.1c0.3-12.6,5.4-19.9,13.7-19.9c8,0,14.8,8.2,14.8,17.7v23.8H255.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.4,
    y: 8.6,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 17.409 77.9591)",
    className: "st0",
    width: 18.8,
    height: 18.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.3,107.8v-0.6c0-3.6,5.5-4.8,5.5-11V63.5c0-6.4-5.5-8-5.5-11.2v-0.4c0-1.3,1.2-2,3-3l18.1-9 c3.6-1.7,5.9,0.3,5.9,2.9v53.5c0,6.2,6.1,7.4,6.1,11v0.6c0,1.4-1.3,2.5-3.3,2.5H92.4C90.6,110.2,89.3,109.2,89.3,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130,107.8v-0.6c0-3.6,5.6-4.8,5.6-10.9V43c0-6.5-5.6-8-5.6-11v-0.6c0-1.4,1.2-2.2,2.9-2.9l18.2-9 c3.8-1.9,5.9,0.1,5.9,2.6v74.2c0,6.1,6.2,7.2,6.2,10.9v0.6c0,1.4-1.4,2.5-3.3,2.5h-26.7C131.3,110.2,130,109.2,130,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.5,107.8v-0.6c0-3.6,5.6-4.8,5.6-10.9V25.1c0-6.5-5.6-8-5.6-11v-0.6c0-1.4,1.2-2.2,2.9-2.9l18.3-9 c3.8-1.9,5.9,0.1,5.9,2.6v92.1c0,6.1,6.2,7.2,6.2,10.9v0.6c0,1.4-1.4,2.5-3.3,2.5h-26.7C171.9,110.2,170.5,109.2,170.5,107.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVillaLogoCropped);
export default __webpack_public_path__ + "static/media/villa-logo-cropped.d4ac6180a3aa7834d88dd735a34b1421.svg";
export { ForwardRef as ReactComponent };